module.exports = __webpack_public_path__ + "static/media/root_logo.70e3cccb.png";